import { useState } from 'react';

import { Controller } from 'libs/control';
import { useSort } from 'libs/hooks';
import { prepareFilter } from 'libs/common';
import { ViolationsGrid } from './grid';
import Filter from './filter';

const sortInitial = [{ field_name: 'violation_time', direction: 'desc' }];
const itemsInitial = {};

export const Violations = (props) => {
  const [items, setItems] = useState(itemsInitial);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [sortParams, setSortParams] = useSort('promise', sortInitial);

  /**
   * prepare params
   * @param {*} data
   * @returns
   */
  const prepareParams = (data) => {
    // console.log('🚀 ~ prepareParams ~ data:', data);
    if (!data) {
      return data;
    }
    const dataOk = { ...data };
    // const key = 'status';
    // if (data[key] === 'active') {
    //   dataOk['is_active'] = true;
    // } else if (data[key] === 'archive') {
    //   dataOk['is_active'] = false;
    // }
    // delete dataOk[key]
    const boolFields = ['is_active'];

    const addParams = {};
    return prepareFilter(dataOk, addParams, { boolFields });
  };

  // grid actions
  const gridActions = {
    addEntries: (data) => setItems({ ...items, ...data }),
    updateEntry: (id, data) => {
      const newItems = { ...items };
      newItems[id] = { ...newItems[id], ...data };
      setItems(newItems);
    },
    clearEntries: () => setItems({}),
    setSortParams: (data) => setSortParams(data),
    setOffset: (val) => setOffset(val),
    setCount: (val) => setCount(val),
  };

  // grid params
  const gridParams = {
    entries: items,
    offset,
    count,
    sortParams,
  };

  return (
    <Controller
      {...props}
      {...gridParams}
      {...gridActions}
      type="violations"
      filterName="violationsFilter"
      grid={ViolationsGrid}
      gridFilter={Filter}
      getRequestParams={prepareParams}
    />
  );
};
